import { styled } from '@mui/material/styles'

const Logo = styled('img')({
  width: '110px',
  height: '139px',
})

export default Logo
